<script setup>
import {computed} from "vue";
import {useStore} from "vuex";

import CodeRender from "@/components/onsiteEditor/components/installation/CodeRender.vue";
import ButtonGroup from "@/components/global/buttons/ButtonGroup.vue";
import InstallationCheckButton from "@/components/onsiteEditor/components/installation/InstallationCheckButton.vue";

const store = useStore();
const emit = defineEmits(['goToAssisted']);

defineProps({
  isOnboarding: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const tabsContent = computed(() => {
  return store.getters['onsiteEditorInstallation/installation']
    .filter(item => item.value === store.getters['onsiteEditorInstallation/activeFilter']);
});

const tabChange = value => store.dispatch('onsiteEditorInstallation/setActiveFilter', value);
</script>

<template>
  <div class="tw-mb-25 tw-flex tw-flex-col tw-rounded-xl tw-bg-white tw-p-8">
    <div class="tw-mb-5 tw-flex tw-flex-col tw-gap-10 tw-text-2xl tw-font-bold tw-leading-8.5 tw-text-slate-100">
      <div>
        Installation
      </div>
      <div class="tw-flex">
        <ButtonGroup
          class="tw-basis-[48%]"
          :items="store.getters['onsiteEditorInstallation/installation']"
          :default="store.getters['onsiteEditorInstallation/activeFilter']"
          @item-changed="tabChange"
        />
      </div>
    </div>
    <div class="tw-flex tw-w-full tw-gap-10 tw-rounded-[10px] tw-bg-white">
      <div class="tw-flex tw-basis-1/2 tw-flex-col">
        <div
          v-for="item in tabsContent"
          :key="item.id"
        >
          <CodeRender
            :website-id="store.getters['user/user'].active_website?.id"
            :text="item.description"
          />
        </div>
      </div>
      <div class="tw-flex tw-basis-1/2">
        <slot />
      </div>
    </div>
    <InstallationCheckButton
      class="tw-mt-5"
      :is-onboarding="isOnboarding"
      @go-to-assisted="emit('goToAssisted')"
    />
  </div>
</template>
